import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material';
import { theme } from './assets/theme/Theme';
import { MainProvider } from './context/MainProvider';

const resizeObserverErrors = [
	'ResizeObserver loop completed with undelivered notifications.',
	'ResizeObserver loop limit exceeded',
];

window.addEventListener('error', event => {
	if (resizeObserverErrors.includes(event.message)) {
		event.stopImmediatePropagation();
	}
});

window.addEventListener('unhandledrejection', event => {
	const message =
		event.reason instanceof Error
			? event.reason.message
			: String(event.reason);

	if (resizeObserverErrors.includes(message)) {
		event.preventDefault();
	}
});

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement,
);

root.render(
	<React.StrictMode>
		<MainProvider>
			<ThemeProvider theme={theme}>
				<App />
			</ThemeProvider>
		</MainProvider>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
